@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides

import com.narbase.letsgo.router.EndPoint

object GetPassengerPreviousRidesEndpoint: EndPoint<GetPassengerPreviousRidesEndpoint.Request, GetPassengerPreviousRidesEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
    )

    class Response(
        val list: Array<PassengerRideDto>,
        val total: Int,
    )
}